

















































































import Vue from 'vue'

declare interface Language {
  text: string,
  value: string,
}

export type DataType = {
  languages: Language[],
}

export default Vue.extend({
  name: 'Header',

  data(): DataType {
    return {
      languages: [
        {
          text: 'čeština',
          value: 'cs',
        },
        {
          text: 'English',
          value: 'en',
        },
        {
          text: '日本語',
          value: 'ja',
        },        
      ],
    }
  },

  methods: {
    switchLanguage(language: string): void {
      this.$i18n.locale = language
      localStorage.setItem('language', language)
    }
  },
})
